import { render, staticRenderFns } from "./vistaBowtie.vue?vue&type=template&id=bad8547c&scoped=true&"
import script from "./vistaBowtie.vue?vue&type=script&lang=js&"
export * from "./vistaBowtie.vue?vue&type=script&lang=js&"
import style0 from "./vistaBowtie.vue?vue&type=style&index=0&id=bad8547c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad8547c",
  null
  
)

component.options.__file = "vistaBowtie.vue"
export default component.exports